//#region IMPORTS
import {
  BuildingStorefrontIcon,
  ChevronRightIcon,
} from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { InstoreTemplate } from "../../models/instoreTemplate";
import { fromBackendDate } from "../../helpers/fromBackendDate";
//#endregion

//#region INTERFACE
interface Props {
  template: InstoreTemplate;
}
//#endregion

export default function BasketEmptyStaticItem({ template }: Props) {
  //#region SETUP
  const { t } = useTranslation();
  const history = useHistory();

  const fromDate = fromBackendDate(template.from);
  const untilDate = fromBackendDate(template.until);
  //#endregion

  //#region RENDER
  return (
    <li
      className="relative flex items-center space-x-6 py-4 hover:cursor-pointer"
      onClick={() => history.push(`/promos/instore/${template.id}`)}
    >
      <div
        className="h-16 w-16 flex-none rounded-full flex items-center justify-center border-2"
        style={{ backgroundColor: "#9eab80", borderColor: "#3e5902" }}
      >
        <BuildingStorefrontIcon
          className="h-6 w-6"
          style={{ color: "#3e5902" }}
          aria-hidden="true"
        />
      </div>

      <div className="min-w-0 flex-1">
        <div className="text-base font-medium text-gray-900">
          <span aria-hidden="true" className="absolute inset-0" />
          Instore orders
        </div>
        <p className="text-base text-gray-500">
          {t("rituals.thisProjectIsAvailableFrom$VAR$until$VAR2$")
            .replace("$VAR$", fromDate)
            .replace("$VAR2$", untilDate)}
        </p>
      </div>
      <div className="self-center">
        <ChevronRightIcon className="w-5 h-5 text-gray-900" />
      </div>
    </li>
  );
  //#endregion
}
